/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as FlexRouteImport } from './routes/flex'
import { Route as ConnectRouteImport } from './routes/connect'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FlexIndexRouteImport } from './routes/flex/index'
import { Route as ConnectIndexRouteImport } from './routes/connect/index'
import { Route as FlexDashboardRouteImport } from './routes/flex/dashboard'
import { Route as FlexIdRouteImport } from './routes/flex/$id'
import { Route as ConnectTeamsRouteImport } from './routes/connect/teams'
import { Route as ConnectReviewsRouteImport } from './routes/connect/reviews'
import { Route as ConnectReportsRouteImport } from './routes/connect/reports'
import { Route as ConnectProfileRouteImport } from './routes/connect/profile'
import { Route as ConnectPaymentsRouteImport } from './routes/connect/payments'
import { Route as ConnectListingsRouteImport } from './routes/connect/listings'
import { Route as ConnectInvoicesRouteImport } from './routes/connect/invoices'
import { Route as ConnectInsightsRouteImport } from './routes/connect/insights'
import { Route as ConnectGrowthAcceleratorRouteImport } from './routes/connect/growth-accelerator'
import { Route as ConnectContractsRouteImport } from './routes/connect/contracts'
import { Route as ConnectCampaignsRouteImport } from './routes/connect/campaigns'
import { Route as ConnectBookingsRouteImport } from './routes/connect/bookings'
import { Route as ConnectAuthCallbackRouteImport } from './routes/connect/auth-callback'
import { Route as FlexDashboardIndexRouteImport } from './routes/flex/dashboard/index'
import { Route as FlexDashboardTeamsRouteImport } from './routes/flex/dashboard/teams'
import { Route as FlexDashboardSupportRouteImport } from './routes/flex/dashboard/support'
import { Route as FlexDashboardSettingsRouteImport } from './routes/flex/dashboard/settings'
import { Route as FlexDashboardSelectRouteImport } from './routes/flex/dashboard/select'
import { Route as FlexDashboardProfileRouteImport } from './routes/flex/dashboard/profile'
import { Route as FlexDashboardListingsRouteImport } from './routes/flex/dashboard/listings'
import { Route as FlexDashboardIntegrationsRouteImport } from './routes/flex/dashboard/integrations'
import { Route as FlexDashboardCustomPageRouteImport } from './routes/flex/dashboard/custom-page'
import { Route as FlexDashboardCustomFormRouteImport } from './routes/flex/dashboard/custom-form'
import { Route as FlexDashboardBookingsRouteImport } from './routes/flex/dashboard/bookings'
import { Route as FlexDashboardIdRouteImport } from './routes/flex/dashboard/$id'
import { Route as FlexDashboardSubpartnersIndexRouteImport } from './routes/flex/dashboard/subpartners/index'
import { Route as FlexDashboardLeadsIndexRouteImport } from './routes/flex/dashboard/leads/index'
import { Route as FlexDashboardContractsIndexRouteImport } from './routes/flex/dashboard/contracts/index'
import { Route as FlexDashboardCommissionsIndexRouteImport } from './routes/flex/dashboard/commissions/index'
import { Route as FlexDashboardCampaignsIndexRouteImport } from './routes/flex/dashboard/campaigns/index'
import { Route as FlexDashboardV2InventoriesRouteImport } from './routes/flex/dashboard/v2/inventories'
import { Route as FlexDashboardInsightsCountriesRouteImport } from './routes/flex/dashboard/insights/countries'
import { Route as FlexDashboardInsightsCitiesRouteImport } from './routes/flex/dashboard/insights/cities'

const PartnerRoute = PartnerRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => rootRouteImport,
} as any)
const FlexRoute = FlexRouteImport.update({
  id: '/flex',
  path: '/flex',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectRoute = ConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FlexIndexRoute = FlexIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FlexRoute,
} as any)
const ConnectIndexRoute = ConnectIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ConnectRoute,
} as any)
const FlexDashboardRoute = FlexDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => FlexRoute,
} as any)
const FlexIdRoute = FlexIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => FlexRoute,
} as any)
const ConnectTeamsRoute = ConnectTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => ConnectRoute,
} as any)
const ConnectReviewsRoute = ConnectReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => ConnectRoute,
} as any)
const ConnectReportsRoute = ConnectReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => ConnectRoute,
} as any)
const ConnectProfileRoute = ConnectProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ConnectRoute,
} as any)
const ConnectPaymentsRoute = ConnectPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => ConnectRoute,
} as any)
const ConnectListingsRoute = ConnectListingsRouteImport.update({
  id: '/listings',
  path: '/listings',
  getParentRoute: () => ConnectRoute,
} as any)
const ConnectInvoicesRoute = ConnectInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => ConnectRoute,
} as any)
const ConnectInsightsRoute = ConnectInsightsRouteImport.update({
  id: '/insights',
  path: '/insights',
  getParentRoute: () => ConnectRoute,
} as any)
const ConnectGrowthAcceleratorRoute =
  ConnectGrowthAcceleratorRouteImport.update({
    id: '/growth-accelerator',
    path: '/growth-accelerator',
    getParentRoute: () => ConnectRoute,
  } as any)
const ConnectContractsRoute = ConnectContractsRouteImport.update({
  id: '/contracts',
  path: '/contracts',
  getParentRoute: () => ConnectRoute,
} as any)
const ConnectCampaignsRoute = ConnectCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => ConnectRoute,
} as any)
const ConnectBookingsRoute = ConnectBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => ConnectRoute,
} as any)
const ConnectAuthCallbackRoute = ConnectAuthCallbackRouteImport.update({
  id: '/auth-callback',
  path: '/auth-callback',
  getParentRoute: () => ConnectRoute,
} as any)
const FlexDashboardIndexRoute = FlexDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardTeamsRoute = FlexDashboardTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardSupportRoute = FlexDashboardSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardSettingsRoute = FlexDashboardSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardSelectRoute = FlexDashboardSelectRouteImport.update({
  id: '/select',
  path: '/select',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardProfileRoute = FlexDashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardListingsRoute = FlexDashboardListingsRouteImport.update({
  id: '/listings',
  path: '/listings',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardIntegrationsRoute =
  FlexDashboardIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => FlexDashboardRoute,
  } as any)
const FlexDashboardCustomPageRoute = FlexDashboardCustomPageRouteImport.update({
  id: '/custom-page',
  path: '/custom-page',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardCustomFormRoute = FlexDashboardCustomFormRouteImport.update({
  id: '/custom-form',
  path: '/custom-form',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardBookingsRoute = FlexDashboardBookingsRouteImport.update({
  id: '/bookings',
  path: '/bookings',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardIdRoute = FlexDashboardIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardSubpartnersIndexRoute =
  FlexDashboardSubpartnersIndexRouteImport.update({
    id: '/subpartners/',
    path: '/subpartners/',
    getParentRoute: () => FlexDashboardRoute,
  } as any)
const FlexDashboardLeadsIndexRoute = FlexDashboardLeadsIndexRouteImport.update({
  id: '/leads/',
  path: '/leads/',
  getParentRoute: () => FlexDashboardRoute,
} as any)
const FlexDashboardContractsIndexRoute =
  FlexDashboardContractsIndexRouteImport.update({
    id: '/contracts/',
    path: '/contracts/',
    getParentRoute: () => FlexDashboardRoute,
  } as any)
const FlexDashboardCommissionsIndexRoute =
  FlexDashboardCommissionsIndexRouteImport.update({
    id: '/commissions/',
    path: '/commissions/',
    getParentRoute: () => FlexDashboardRoute,
  } as any)
const FlexDashboardCampaignsIndexRoute =
  FlexDashboardCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => FlexDashboardRoute,
  } as any)
const FlexDashboardV2InventoriesRoute =
  FlexDashboardV2InventoriesRouteImport.update({
    id: '/v2/inventories',
    path: '/v2/inventories',
    getParentRoute: () => FlexDashboardRoute,
  } as any)
const FlexDashboardInsightsCountriesRoute =
  FlexDashboardInsightsCountriesRouteImport.update({
    id: '/insights/countries',
    path: '/insights/countries',
    getParentRoute: () => FlexDashboardRoute,
  } as any)
const FlexDashboardInsightsCitiesRoute =
  FlexDashboardInsightsCitiesRouteImport.update({
    id: '/insights/cities',
    path: '/insights/cities',
    getParentRoute: () => FlexDashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/connect': typeof ConnectRouteWithChildren
  '/flex': typeof FlexRouteWithChildren
  '/partner': typeof PartnerRoute
  '/connect/auth-callback': typeof ConnectAuthCallbackRoute
  '/connect/bookings': typeof ConnectBookingsRoute
  '/connect/campaigns': typeof ConnectCampaignsRoute
  '/connect/contracts': typeof ConnectContractsRoute
  '/connect/growth-accelerator': typeof ConnectGrowthAcceleratorRoute
  '/connect/insights': typeof ConnectInsightsRoute
  '/connect/invoices': typeof ConnectInvoicesRoute
  '/connect/listings': typeof ConnectListingsRoute
  '/connect/payments': typeof ConnectPaymentsRoute
  '/connect/profile': typeof ConnectProfileRoute
  '/connect/reports': typeof ConnectReportsRoute
  '/connect/reviews': typeof ConnectReviewsRoute
  '/connect/teams': typeof ConnectTeamsRoute
  '/flex/$id': typeof FlexIdRoute
  '/flex/dashboard': typeof FlexDashboardRouteWithChildren
  '/connect/': typeof ConnectIndexRoute
  '/flex/': typeof FlexIndexRoute
  '/flex/dashboard/$id': typeof FlexDashboardIdRoute
  '/flex/dashboard/bookings': typeof FlexDashboardBookingsRoute
  '/flex/dashboard/custom-form': typeof FlexDashboardCustomFormRoute
  '/flex/dashboard/custom-page': typeof FlexDashboardCustomPageRoute
  '/flex/dashboard/integrations': typeof FlexDashboardIntegrationsRoute
  '/flex/dashboard/listings': typeof FlexDashboardListingsRoute
  '/flex/dashboard/profile': typeof FlexDashboardProfileRoute
  '/flex/dashboard/select': typeof FlexDashboardSelectRoute
  '/flex/dashboard/settings': typeof FlexDashboardSettingsRoute
  '/flex/dashboard/support': typeof FlexDashboardSupportRoute
  '/flex/dashboard/teams': typeof FlexDashboardTeamsRoute
  '/flex/dashboard/': typeof FlexDashboardIndexRoute
  '/flex/dashboard/insights/cities': typeof FlexDashboardInsightsCitiesRoute
  '/flex/dashboard/insights/countries': typeof FlexDashboardInsightsCountriesRoute
  '/flex/dashboard/v2/inventories': typeof FlexDashboardV2InventoriesRoute
  '/flex/dashboard/campaigns': typeof FlexDashboardCampaignsIndexRoute
  '/flex/dashboard/commissions': typeof FlexDashboardCommissionsIndexRoute
  '/flex/dashboard/contracts': typeof FlexDashboardContractsIndexRoute
  '/flex/dashboard/leads': typeof FlexDashboardLeadsIndexRoute
  '/flex/dashboard/subpartners': typeof FlexDashboardSubpartnersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/partner': typeof PartnerRoute
  '/connect/auth-callback': typeof ConnectAuthCallbackRoute
  '/connect/bookings': typeof ConnectBookingsRoute
  '/connect/campaigns': typeof ConnectCampaignsRoute
  '/connect/contracts': typeof ConnectContractsRoute
  '/connect/growth-accelerator': typeof ConnectGrowthAcceleratorRoute
  '/connect/insights': typeof ConnectInsightsRoute
  '/connect/invoices': typeof ConnectInvoicesRoute
  '/connect/listings': typeof ConnectListingsRoute
  '/connect/payments': typeof ConnectPaymentsRoute
  '/connect/profile': typeof ConnectProfileRoute
  '/connect/reports': typeof ConnectReportsRoute
  '/connect/reviews': typeof ConnectReviewsRoute
  '/connect/teams': typeof ConnectTeamsRoute
  '/flex/$id': typeof FlexIdRoute
  '/connect': typeof ConnectIndexRoute
  '/flex': typeof FlexIndexRoute
  '/flex/dashboard/$id': typeof FlexDashboardIdRoute
  '/flex/dashboard/bookings': typeof FlexDashboardBookingsRoute
  '/flex/dashboard/custom-form': typeof FlexDashboardCustomFormRoute
  '/flex/dashboard/custom-page': typeof FlexDashboardCustomPageRoute
  '/flex/dashboard/integrations': typeof FlexDashboardIntegrationsRoute
  '/flex/dashboard/listings': typeof FlexDashboardListingsRoute
  '/flex/dashboard/profile': typeof FlexDashboardProfileRoute
  '/flex/dashboard/select': typeof FlexDashboardSelectRoute
  '/flex/dashboard/settings': typeof FlexDashboardSettingsRoute
  '/flex/dashboard/support': typeof FlexDashboardSupportRoute
  '/flex/dashboard/teams': typeof FlexDashboardTeamsRoute
  '/flex/dashboard': typeof FlexDashboardIndexRoute
  '/flex/dashboard/insights/cities': typeof FlexDashboardInsightsCitiesRoute
  '/flex/dashboard/insights/countries': typeof FlexDashboardInsightsCountriesRoute
  '/flex/dashboard/v2/inventories': typeof FlexDashboardV2InventoriesRoute
  '/flex/dashboard/campaigns': typeof FlexDashboardCampaignsIndexRoute
  '/flex/dashboard/commissions': typeof FlexDashboardCommissionsIndexRoute
  '/flex/dashboard/contracts': typeof FlexDashboardContractsIndexRoute
  '/flex/dashboard/leads': typeof FlexDashboardLeadsIndexRoute
  '/flex/dashboard/subpartners': typeof FlexDashboardSubpartnersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/connect': typeof ConnectRouteWithChildren
  '/flex': typeof FlexRouteWithChildren
  '/partner': typeof PartnerRoute
  '/connect/auth-callback': typeof ConnectAuthCallbackRoute
  '/connect/bookings': typeof ConnectBookingsRoute
  '/connect/campaigns': typeof ConnectCampaignsRoute
  '/connect/contracts': typeof ConnectContractsRoute
  '/connect/growth-accelerator': typeof ConnectGrowthAcceleratorRoute
  '/connect/insights': typeof ConnectInsightsRoute
  '/connect/invoices': typeof ConnectInvoicesRoute
  '/connect/listings': typeof ConnectListingsRoute
  '/connect/payments': typeof ConnectPaymentsRoute
  '/connect/profile': typeof ConnectProfileRoute
  '/connect/reports': typeof ConnectReportsRoute
  '/connect/reviews': typeof ConnectReviewsRoute
  '/connect/teams': typeof ConnectTeamsRoute
  '/flex/$id': typeof FlexIdRoute
  '/flex/dashboard': typeof FlexDashboardRouteWithChildren
  '/connect/': typeof ConnectIndexRoute
  '/flex/': typeof FlexIndexRoute
  '/flex/dashboard/$id': typeof FlexDashboardIdRoute
  '/flex/dashboard/bookings': typeof FlexDashboardBookingsRoute
  '/flex/dashboard/custom-form': typeof FlexDashboardCustomFormRoute
  '/flex/dashboard/custom-page': typeof FlexDashboardCustomPageRoute
  '/flex/dashboard/integrations': typeof FlexDashboardIntegrationsRoute
  '/flex/dashboard/listings': typeof FlexDashboardListingsRoute
  '/flex/dashboard/profile': typeof FlexDashboardProfileRoute
  '/flex/dashboard/select': typeof FlexDashboardSelectRoute
  '/flex/dashboard/settings': typeof FlexDashboardSettingsRoute
  '/flex/dashboard/support': typeof FlexDashboardSupportRoute
  '/flex/dashboard/teams': typeof FlexDashboardTeamsRoute
  '/flex/dashboard/': typeof FlexDashboardIndexRoute
  '/flex/dashboard/insights/cities': typeof FlexDashboardInsightsCitiesRoute
  '/flex/dashboard/insights/countries': typeof FlexDashboardInsightsCountriesRoute
  '/flex/dashboard/v2/inventories': typeof FlexDashboardV2InventoriesRoute
  '/flex/dashboard/campaigns/': typeof FlexDashboardCampaignsIndexRoute
  '/flex/dashboard/commissions/': typeof FlexDashboardCommissionsIndexRoute
  '/flex/dashboard/contracts/': typeof FlexDashboardContractsIndexRoute
  '/flex/dashboard/leads/': typeof FlexDashboardLeadsIndexRoute
  '/flex/dashboard/subpartners/': typeof FlexDashboardSubpartnersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connect'
    | '/flex'
    | '/partner'
    | '/connect/auth-callback'
    | '/connect/bookings'
    | '/connect/campaigns'
    | '/connect/contracts'
    | '/connect/growth-accelerator'
    | '/connect/insights'
    | '/connect/invoices'
    | '/connect/listings'
    | '/connect/payments'
    | '/connect/profile'
    | '/connect/reports'
    | '/connect/reviews'
    | '/connect/teams'
    | '/flex/$id'
    | '/flex/dashboard'
    | '/connect/'
    | '/flex/'
    | '/flex/dashboard/$id'
    | '/flex/dashboard/bookings'
    | '/flex/dashboard/custom-form'
    | '/flex/dashboard/custom-page'
    | '/flex/dashboard/integrations'
    | '/flex/dashboard/listings'
    | '/flex/dashboard/profile'
    | '/flex/dashboard/select'
    | '/flex/dashboard/settings'
    | '/flex/dashboard/support'
    | '/flex/dashboard/teams'
    | '/flex/dashboard/'
    | '/flex/dashboard/insights/cities'
    | '/flex/dashboard/insights/countries'
    | '/flex/dashboard/v2/inventories'
    | '/flex/dashboard/campaigns'
    | '/flex/dashboard/commissions'
    | '/flex/dashboard/contracts'
    | '/flex/dashboard/leads'
    | '/flex/dashboard/subpartners'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/partner'
    | '/connect/auth-callback'
    | '/connect/bookings'
    | '/connect/campaigns'
    | '/connect/contracts'
    | '/connect/growth-accelerator'
    | '/connect/insights'
    | '/connect/invoices'
    | '/connect/listings'
    | '/connect/payments'
    | '/connect/profile'
    | '/connect/reports'
    | '/connect/reviews'
    | '/connect/teams'
    | '/flex/$id'
    | '/connect'
    | '/flex'
    | '/flex/dashboard/$id'
    | '/flex/dashboard/bookings'
    | '/flex/dashboard/custom-form'
    | '/flex/dashboard/custom-page'
    | '/flex/dashboard/integrations'
    | '/flex/dashboard/listings'
    | '/flex/dashboard/profile'
    | '/flex/dashboard/select'
    | '/flex/dashboard/settings'
    | '/flex/dashboard/support'
    | '/flex/dashboard/teams'
    | '/flex/dashboard'
    | '/flex/dashboard/insights/cities'
    | '/flex/dashboard/insights/countries'
    | '/flex/dashboard/v2/inventories'
    | '/flex/dashboard/campaigns'
    | '/flex/dashboard/commissions'
    | '/flex/dashboard/contracts'
    | '/flex/dashboard/leads'
    | '/flex/dashboard/subpartners'
  id:
    | '__root__'
    | '/'
    | '/connect'
    | '/flex'
    | '/partner'
    | '/connect/auth-callback'
    | '/connect/bookings'
    | '/connect/campaigns'
    | '/connect/contracts'
    | '/connect/growth-accelerator'
    | '/connect/insights'
    | '/connect/invoices'
    | '/connect/listings'
    | '/connect/payments'
    | '/connect/profile'
    | '/connect/reports'
    | '/connect/reviews'
    | '/connect/teams'
    | '/flex/$id'
    | '/flex/dashboard'
    | '/connect/'
    | '/flex/'
    | '/flex/dashboard/$id'
    | '/flex/dashboard/bookings'
    | '/flex/dashboard/custom-form'
    | '/flex/dashboard/custom-page'
    | '/flex/dashboard/integrations'
    | '/flex/dashboard/listings'
    | '/flex/dashboard/profile'
    | '/flex/dashboard/select'
    | '/flex/dashboard/settings'
    | '/flex/dashboard/support'
    | '/flex/dashboard/teams'
    | '/flex/dashboard/'
    | '/flex/dashboard/insights/cities'
    | '/flex/dashboard/insights/countries'
    | '/flex/dashboard/v2/inventories'
    | '/flex/dashboard/campaigns/'
    | '/flex/dashboard/commissions/'
    | '/flex/dashboard/contracts/'
    | '/flex/dashboard/leads/'
    | '/flex/dashboard/subpartners/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConnectRoute: typeof ConnectRouteWithChildren
  FlexRoute: typeof FlexRouteWithChildren
  PartnerRoute: typeof PartnerRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/partner': {
      id: '/partner'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof PartnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flex': {
      id: '/flex'
      path: '/flex'
      fullPath: '/flex'
      preLoaderRoute: typeof FlexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof ConnectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flex/': {
      id: '/flex/'
      path: '/'
      fullPath: '/flex/'
      preLoaderRoute: typeof FlexIndexRouteImport
      parentRoute: typeof FlexRoute
    }
    '/connect/': {
      id: '/connect/'
      path: '/'
      fullPath: '/connect/'
      preLoaderRoute: typeof ConnectIndexRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/flex/dashboard': {
      id: '/flex/dashboard'
      path: '/dashboard'
      fullPath: '/flex/dashboard'
      preLoaderRoute: typeof FlexDashboardRouteImport
      parentRoute: typeof FlexRoute
    }
    '/flex/$id': {
      id: '/flex/$id'
      path: '/$id'
      fullPath: '/flex/$id'
      preLoaderRoute: typeof FlexIdRouteImport
      parentRoute: typeof FlexRoute
    }
    '/connect/teams': {
      id: '/connect/teams'
      path: '/teams'
      fullPath: '/connect/teams'
      preLoaderRoute: typeof ConnectTeamsRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/reviews': {
      id: '/connect/reviews'
      path: '/reviews'
      fullPath: '/connect/reviews'
      preLoaderRoute: typeof ConnectReviewsRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/reports': {
      id: '/connect/reports'
      path: '/reports'
      fullPath: '/connect/reports'
      preLoaderRoute: typeof ConnectReportsRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/profile': {
      id: '/connect/profile'
      path: '/profile'
      fullPath: '/connect/profile'
      preLoaderRoute: typeof ConnectProfileRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/payments': {
      id: '/connect/payments'
      path: '/payments'
      fullPath: '/connect/payments'
      preLoaderRoute: typeof ConnectPaymentsRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/listings': {
      id: '/connect/listings'
      path: '/listings'
      fullPath: '/connect/listings'
      preLoaderRoute: typeof ConnectListingsRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/invoices': {
      id: '/connect/invoices'
      path: '/invoices'
      fullPath: '/connect/invoices'
      preLoaderRoute: typeof ConnectInvoicesRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/insights': {
      id: '/connect/insights'
      path: '/insights'
      fullPath: '/connect/insights'
      preLoaderRoute: typeof ConnectInsightsRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/growth-accelerator': {
      id: '/connect/growth-accelerator'
      path: '/growth-accelerator'
      fullPath: '/connect/growth-accelerator'
      preLoaderRoute: typeof ConnectGrowthAcceleratorRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/contracts': {
      id: '/connect/contracts'
      path: '/contracts'
      fullPath: '/connect/contracts'
      preLoaderRoute: typeof ConnectContractsRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/campaigns': {
      id: '/connect/campaigns'
      path: '/campaigns'
      fullPath: '/connect/campaigns'
      preLoaderRoute: typeof ConnectCampaignsRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/bookings': {
      id: '/connect/bookings'
      path: '/bookings'
      fullPath: '/connect/bookings'
      preLoaderRoute: typeof ConnectBookingsRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/connect/auth-callback': {
      id: '/connect/auth-callback'
      path: '/auth-callback'
      fullPath: '/connect/auth-callback'
      preLoaderRoute: typeof ConnectAuthCallbackRouteImport
      parentRoute: typeof ConnectRoute
    }
    '/flex/dashboard/': {
      id: '/flex/dashboard/'
      path: '/'
      fullPath: '/flex/dashboard/'
      preLoaderRoute: typeof FlexDashboardIndexRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/teams': {
      id: '/flex/dashboard/teams'
      path: '/teams'
      fullPath: '/flex/dashboard/teams'
      preLoaderRoute: typeof FlexDashboardTeamsRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/support': {
      id: '/flex/dashboard/support'
      path: '/support'
      fullPath: '/flex/dashboard/support'
      preLoaderRoute: typeof FlexDashboardSupportRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/settings': {
      id: '/flex/dashboard/settings'
      path: '/settings'
      fullPath: '/flex/dashboard/settings'
      preLoaderRoute: typeof FlexDashboardSettingsRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/select': {
      id: '/flex/dashboard/select'
      path: '/select'
      fullPath: '/flex/dashboard/select'
      preLoaderRoute: typeof FlexDashboardSelectRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/profile': {
      id: '/flex/dashboard/profile'
      path: '/profile'
      fullPath: '/flex/dashboard/profile'
      preLoaderRoute: typeof FlexDashboardProfileRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/listings': {
      id: '/flex/dashboard/listings'
      path: '/listings'
      fullPath: '/flex/dashboard/listings'
      preLoaderRoute: typeof FlexDashboardListingsRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/integrations': {
      id: '/flex/dashboard/integrations'
      path: '/integrations'
      fullPath: '/flex/dashboard/integrations'
      preLoaderRoute: typeof FlexDashboardIntegrationsRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/custom-page': {
      id: '/flex/dashboard/custom-page'
      path: '/custom-page'
      fullPath: '/flex/dashboard/custom-page'
      preLoaderRoute: typeof FlexDashboardCustomPageRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/custom-form': {
      id: '/flex/dashboard/custom-form'
      path: '/custom-form'
      fullPath: '/flex/dashboard/custom-form'
      preLoaderRoute: typeof FlexDashboardCustomFormRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/bookings': {
      id: '/flex/dashboard/bookings'
      path: '/bookings'
      fullPath: '/flex/dashboard/bookings'
      preLoaderRoute: typeof FlexDashboardBookingsRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/$id': {
      id: '/flex/dashboard/$id'
      path: '/$id'
      fullPath: '/flex/dashboard/$id'
      preLoaderRoute: typeof FlexDashboardIdRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/subpartners/': {
      id: '/flex/dashboard/subpartners/'
      path: '/subpartners'
      fullPath: '/flex/dashboard/subpartners'
      preLoaderRoute: typeof FlexDashboardSubpartnersIndexRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/leads/': {
      id: '/flex/dashboard/leads/'
      path: '/leads'
      fullPath: '/flex/dashboard/leads'
      preLoaderRoute: typeof FlexDashboardLeadsIndexRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/contracts/': {
      id: '/flex/dashboard/contracts/'
      path: '/contracts'
      fullPath: '/flex/dashboard/contracts'
      preLoaderRoute: typeof FlexDashboardContractsIndexRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/commissions/': {
      id: '/flex/dashboard/commissions/'
      path: '/commissions'
      fullPath: '/flex/dashboard/commissions'
      preLoaderRoute: typeof FlexDashboardCommissionsIndexRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/campaigns/': {
      id: '/flex/dashboard/campaigns/'
      path: '/campaigns'
      fullPath: '/flex/dashboard/campaigns'
      preLoaderRoute: typeof FlexDashboardCampaignsIndexRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/v2/inventories': {
      id: '/flex/dashboard/v2/inventories'
      path: '/v2/inventories'
      fullPath: '/flex/dashboard/v2/inventories'
      preLoaderRoute: typeof FlexDashboardV2InventoriesRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/insights/countries': {
      id: '/flex/dashboard/insights/countries'
      path: '/insights/countries'
      fullPath: '/flex/dashboard/insights/countries'
      preLoaderRoute: typeof FlexDashboardInsightsCountriesRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
    '/flex/dashboard/insights/cities': {
      id: '/flex/dashboard/insights/cities'
      path: '/insights/cities'
      fullPath: '/flex/dashboard/insights/cities'
      preLoaderRoute: typeof FlexDashboardInsightsCitiesRouteImport
      parentRoute: typeof FlexDashboardRoute
    }
  }
}

interface ConnectRouteChildren {
  ConnectAuthCallbackRoute: typeof ConnectAuthCallbackRoute
  ConnectBookingsRoute: typeof ConnectBookingsRoute
  ConnectCampaignsRoute: typeof ConnectCampaignsRoute
  ConnectContractsRoute: typeof ConnectContractsRoute
  ConnectGrowthAcceleratorRoute: typeof ConnectGrowthAcceleratorRoute
  ConnectInsightsRoute: typeof ConnectInsightsRoute
  ConnectInvoicesRoute: typeof ConnectInvoicesRoute
  ConnectListingsRoute: typeof ConnectListingsRoute
  ConnectPaymentsRoute: typeof ConnectPaymentsRoute
  ConnectProfileRoute: typeof ConnectProfileRoute
  ConnectReportsRoute: typeof ConnectReportsRoute
  ConnectReviewsRoute: typeof ConnectReviewsRoute
  ConnectTeamsRoute: typeof ConnectTeamsRoute
  ConnectIndexRoute: typeof ConnectIndexRoute
}

const ConnectRouteChildren: ConnectRouteChildren = {
  ConnectAuthCallbackRoute: ConnectAuthCallbackRoute,
  ConnectBookingsRoute: ConnectBookingsRoute,
  ConnectCampaignsRoute: ConnectCampaignsRoute,
  ConnectContractsRoute: ConnectContractsRoute,
  ConnectGrowthAcceleratorRoute: ConnectGrowthAcceleratorRoute,
  ConnectInsightsRoute: ConnectInsightsRoute,
  ConnectInvoicesRoute: ConnectInvoicesRoute,
  ConnectListingsRoute: ConnectListingsRoute,
  ConnectPaymentsRoute: ConnectPaymentsRoute,
  ConnectProfileRoute: ConnectProfileRoute,
  ConnectReportsRoute: ConnectReportsRoute,
  ConnectReviewsRoute: ConnectReviewsRoute,
  ConnectTeamsRoute: ConnectTeamsRoute,
  ConnectIndexRoute: ConnectIndexRoute,
}

const ConnectRouteWithChildren =
  ConnectRoute._addFileChildren(ConnectRouteChildren)

interface FlexDashboardRouteChildren {
  FlexDashboardIdRoute: typeof FlexDashboardIdRoute
  FlexDashboardBookingsRoute: typeof FlexDashboardBookingsRoute
  FlexDashboardCustomFormRoute: typeof FlexDashboardCustomFormRoute
  FlexDashboardCustomPageRoute: typeof FlexDashboardCustomPageRoute
  FlexDashboardIntegrationsRoute: typeof FlexDashboardIntegrationsRoute
  FlexDashboardListingsRoute: typeof FlexDashboardListingsRoute
  FlexDashboardProfileRoute: typeof FlexDashboardProfileRoute
  FlexDashboardSelectRoute: typeof FlexDashboardSelectRoute
  FlexDashboardSettingsRoute: typeof FlexDashboardSettingsRoute
  FlexDashboardSupportRoute: typeof FlexDashboardSupportRoute
  FlexDashboardTeamsRoute: typeof FlexDashboardTeamsRoute
  FlexDashboardIndexRoute: typeof FlexDashboardIndexRoute
  FlexDashboardInsightsCitiesRoute: typeof FlexDashboardInsightsCitiesRoute
  FlexDashboardInsightsCountriesRoute: typeof FlexDashboardInsightsCountriesRoute
  FlexDashboardV2InventoriesRoute: typeof FlexDashboardV2InventoriesRoute
  FlexDashboardCampaignsIndexRoute: typeof FlexDashboardCampaignsIndexRoute
  FlexDashboardCommissionsIndexRoute: typeof FlexDashboardCommissionsIndexRoute
  FlexDashboardContractsIndexRoute: typeof FlexDashboardContractsIndexRoute
  FlexDashboardLeadsIndexRoute: typeof FlexDashboardLeadsIndexRoute
  FlexDashboardSubpartnersIndexRoute: typeof FlexDashboardSubpartnersIndexRoute
}

const FlexDashboardRouteChildren: FlexDashboardRouteChildren = {
  FlexDashboardIdRoute: FlexDashboardIdRoute,
  FlexDashboardBookingsRoute: FlexDashboardBookingsRoute,
  FlexDashboardCustomFormRoute: FlexDashboardCustomFormRoute,
  FlexDashboardCustomPageRoute: FlexDashboardCustomPageRoute,
  FlexDashboardIntegrationsRoute: FlexDashboardIntegrationsRoute,
  FlexDashboardListingsRoute: FlexDashboardListingsRoute,
  FlexDashboardProfileRoute: FlexDashboardProfileRoute,
  FlexDashboardSelectRoute: FlexDashboardSelectRoute,
  FlexDashboardSettingsRoute: FlexDashboardSettingsRoute,
  FlexDashboardSupportRoute: FlexDashboardSupportRoute,
  FlexDashboardTeamsRoute: FlexDashboardTeamsRoute,
  FlexDashboardIndexRoute: FlexDashboardIndexRoute,
  FlexDashboardInsightsCitiesRoute: FlexDashboardInsightsCitiesRoute,
  FlexDashboardInsightsCountriesRoute: FlexDashboardInsightsCountriesRoute,
  FlexDashboardV2InventoriesRoute: FlexDashboardV2InventoriesRoute,
  FlexDashboardCampaignsIndexRoute: FlexDashboardCampaignsIndexRoute,
  FlexDashboardCommissionsIndexRoute: FlexDashboardCommissionsIndexRoute,
  FlexDashboardContractsIndexRoute: FlexDashboardContractsIndexRoute,
  FlexDashboardLeadsIndexRoute: FlexDashboardLeadsIndexRoute,
  FlexDashboardSubpartnersIndexRoute: FlexDashboardSubpartnersIndexRoute,
}

const FlexDashboardRouteWithChildren = FlexDashboardRoute._addFileChildren(
  FlexDashboardRouteChildren,
)

interface FlexRouteChildren {
  FlexIdRoute: typeof FlexIdRoute
  FlexDashboardRoute: typeof FlexDashboardRouteWithChildren
  FlexIndexRoute: typeof FlexIndexRoute
}

const FlexRouteChildren: FlexRouteChildren = {
  FlexIdRoute: FlexIdRoute,
  FlexDashboardRoute: FlexDashboardRouteWithChildren,
  FlexIndexRoute: FlexIndexRoute,
}

const FlexRouteWithChildren = FlexRoute._addFileChildren(FlexRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConnectRoute: ConnectRouteWithChildren,
  FlexRoute: FlexRouteWithChildren,
  PartnerRoute: PartnerRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
